import React from "react";

import Section from "../../../components/Section";
import Background from "../../../components/Background";

import style from "./style.module.css";

export default function Image ({image}) {
    return (
        <Section className={style.image}>
            <div className={style.imageWrap}>
                <Background src={image} size="2286x1284" cPosition="topLeft" />
            </div>
        </Section>
    )
}